var _rect, _rect2, _path, _rect3, _rect4, _path2, _rect5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwords(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.6672,
    y: 14,
    width: 1.88563,
    height: 4.71409,
    transform: "rotate(-45 12.6672 14)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.66699,
    y: 15,
    width: 7.54254,
    height: 1.41423,
    transform: "rotate(-45 9.66699 15)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 4.66701L1.33335 1.33365L4.66671 2.00032L13.6668 11.0004L11.0001 13.6671L2.00002 4.66701Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.00049,
    y: 12.667,
    width: 1.88563,
    height: 4.71409,
    transform: "rotate(45 4.00049 12.667)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.33325,
    y: 10,
    width: 6.59972,
    height: 1.41423,
    transform: "rotate(45 3.33325 10)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4446 1.88891L16.6668 1.33335L16.1113 4.5556L12.3335 8.33341L9.66678 5.66672L13.4446 1.88891Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.33325,
    y: 11,
    width: 1.88563,
    height: 3.77127,
    transform: "rotate(-45 4.33325 11)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwords);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0iIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSIxMi42NjcyIiB5PSIxNCIgd2lkdGg9IjEuODg1NjMiIGhlaWdodD0iNC43MTQwOSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDEyLjY2NzIgMTQpIi8+CjxyZWN0IHg9IjkuNjY2OTkiIHk9IjE1IiB3aWR0aD0iNy41NDI1NCIgaGVpZ2h0PSIxLjQxNDIzIiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgOS42NjY5OSAxNSkiLz4KPHBhdGggZD0iTTIuMDAwMDIgNC42NjcwMUwxLjMzMzM1IDEuMzMzNjVMNC42NjY3MSAyLjAwMDMyTDEzLjY2NjggMTEuMDAwNEwxMS4wMDAxIDEzLjY2NzFMMi4wMDAwMiA0LjY2NzAxWiIgLz4KPHJlY3QgeD0iNC4wMDA0OSIgeT0iMTIuNjY3IiB3aWR0aD0iMS44ODU2MyIgaGVpZ2h0PSI0LjcxNDA5IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSA0LjAwMDQ5IDEyLjY2NykiLz4KPHJlY3QgeD0iMy4zMzMyNSIgeT0iMTAiIHdpZHRoPSI2LjU5OTcyIiBoZWlnaHQ9IjEuNDE0MjMiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDMuMzMzMjUgMTApIi8+CjxwYXRoIGQ9Ik0xMy40NDQ2IDEuODg4OTFMMTYuNjY2OCAxLjMzMzM1TDE2LjExMTMgNC41NTU2TDEyLjMzMzUgOC4zMzM0MUw5LjY2Njc4IDUuNjY2NzJMMTMuNDQ0NiAxLjg4ODkxWiIvPgo8cmVjdCB4PSI0LjMzMzI1IiB5PSIxMSIgd2lkdGg9IjEuODg1NjMiIGhlaWdodD0iMy43NzEyNyIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDQuMzMzMjUgMTEpIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };